import React from 'react'
import { observer } from 'mobx-react-lite'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import { SUMMARY_MODE } from 'widgets/NoteTaker/types/sessionDrawer'
import { ReactComponent as StarsIcon } from 'assets/icons/stars-2.svg'
import AutoGrowTextarea from './AutoGrowTextarea'
import s from '../NoteTakerDrawer.module.scss'

const SessionSummarySection = observer(() => {
	const summaryText = noteTakerStore.summarySaved
	const isEditing = noteTakerStore.summaryMode === SUMMARY_MODE.EDIT
	const paragraphs = summaryText
		.split(/\n+/)
		.map(part => part.trim())
		.filter(Boolean)

	return (
		<section className={s.summaryCard}>
			<div className={s.summaryHead}>
				<div className={s.summaryTitle}>
					<StarsIcon />
					<span>AI Summary</span>
				</div>
				{!isEditing ? (
					<button
						type="button"
						className={s.editSummaryButton}
						onClick={() => noteTakerStore.beginSummaryEdit()}
					>
						Edit
					</button>
				) : null}
			</div>

			{isEditing ? (
				<>
					<AutoGrowTextarea
						className={s.summaryEditor}
						value={noteTakerStore.summaryDraft}
						onChange={event => noteTakerStore.setSummaryDraft(event.target.value)}
						minHeight={120}
						placeholder="Write the session summary..."
					/>
					{noteTakerStore.summarySaveError ? (
						<div className={s.inlineError}>{noteTakerStore.summarySaveError.message}</div>
					) : null}
					<div className={s.editBar}>
						<button
							type="button"
							className={s.secondaryButton}
							onClick={() => noteTakerStore.cancelSummaryEdit()}
							disabled={noteTakerStore.summarySaveStatus === 'saving'}
						>
							Cancel
						</button>
						<button
							type="button"
							className={s.primaryButton}
							onClick={() => noteTakerStore.saveSummary()}
							disabled={noteTakerStore.summarySaveStatus === 'saving'}
						>
							{noteTakerStore.summarySaveStatus === 'saving' ? 'Saving...' : 'Save'}
						</button>
					</div>
				</>
			) : (
				<div className={s.summaryBody}>
					{paragraphs.length > 0 ? (
						paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)
					) : (
						<p className={s.summaryEmpty}>No summary yet.</p>
					)}
				</div>
			)}
		</section>
	)
})

export default SessionSummarySection
